


















































































import Vue from 'vue'
import { COMPANY_GET_BASIC_COMPANY_STRUCTURE, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { Employee } from '@/model/companyStructure/Employee'
import { Address } from '@/model/planning/Address'
import {
  EDIT_ADDITIONAL_SERVICE_EXPENSES,
  INSERT_ADDITIONAL_SERVICE_EXPENSES, SEARCH_ADDRESS_LIST
} from '@/store/action-types'
import { AdditionalServicePayload } from '@/types/payload'
import moment from 'moment'
import { SnackbarStateEnum } from '@/types/enums'
import { Currency } from '@/model/planning/Currency'
import { AdditionalServices } from '@/model/planning/AdditionalServices'
import { DatePeriod } from '@/model/DatePeriod'
import { TranslateResult } from 'vue-i18n'
import AdditionalServicesWarningDialog from '@/components/planning/AdditionalServicesWarningDialog.vue'

interface ComponentData {
  saveInProgress: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  valid: boolean
  validationRules: Array<Function>
  numberValidationRules: Array<Function>
  addressList: Address[]
  address: Address | null
  addressLabel: string
  employeeList: Employee[]
  employee: number | null
  selectedCurrency: Currency | null
  selectedCurrencyName: string
  amount: string | null
  search: string | null
  selected: boolean
  isLoading: boolean
  description: string

  showWarningDialog: boolean
  month1: string
  month2: string
}

export default Vue.extend({
  name: 'AdditionalServicesExpensesFormDialog',

  components: {
    AdditionalServicesWarningDialog
  },

  props: {
    show: Boolean,
    title: String,
    dialogData: {
      type: Object as () => AdditionalServices
    },
    currencyList: Array as () => Currency[],
    isEdit: Boolean,
    expensesAction: Number,
    period: Object as () => DatePeriod,
    defaultCurrency: Number
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.addresses.required').toString()
    const numberRule = (value: any): boolean | string => (!!value && value > 0) || this.$t('masterData.addresses.required').toString()

    return {
      saveInProgress: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      valid: true,
      validationRules: [required],
      numberValidationRules: [numberRule],
      addressList: [],
      address: null,
      addressLabel: '',
      employeeList: [],
      employee: null,
      selectedCurrency: null,
      selectedCurrencyName: '',
      amount: null,
      search: null,
      selected: false,
      isLoading: false,
      description: '',

      showWarningDialog: false,
      month1: '',
      month2: ''
    }
  },

  watch: {
    search (newVal: string): void {
      // Items have already been requested
      if (this.isLoading) return

      // Lazily load input items
      if(newVal && newVal.length > 2 && !this.selected) {
        this.searchAddress()
      }

      this.selected = false
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLanguage (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onAmountChange (): void {
      if(this.amount && parseFloat(this.amount) !== 0) {
        this.amount =  parseFloat(this.amount).toFixed(2).toString()
      } else {
        this.amount = null
      }
    },

    onAddressSelect (): void {
      this.selected = true
    },

    async searchAddress(): Promise<void> {
      this.isLoading = true
      try {
        const data: Array<Address> = await this.$store.dispatch(SEARCH_ADDRESS_LIST, this.search)
        this.addressList = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
      }
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onWarningDialogClose (): void {
      this.showWarningDialog = false
    },

    onWarningDialogSave (item: number): void {
      this.save(item)
      this.showWarningDialog = false
    },

    onSaveButtonClick () {
      this.save()
    },

    save (item?: number): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
        if (this.isEdit) {
          const payload: AdditionalServicePayload = {
            id: this.isEdit ? this.dialogData.id : null,
            LGID: null,
            addressId: this.isEdit ? this.dialogData.addressId : this.address ? this.address.id : 0,
            year: parseInt(moment(this.period!.startDate).format('YYYY')),
            month: parseInt(moment(this.period!.startDate).format('M')),
            employeeId: this.employee ? this.employee : 0,
            productId: 0,
            amount: 1,
            price: parseFloat(this.amount!),
            description: this.description,
            currency: this.selectedCurrency!.name,
            type: this.expensesAction === 1 ? '1' : '2'
          }

          this.editAdditionExpensesService(payload)

        } else if (moment(this.period!.startDate).format('M') === moment(this.period!.endDate).format('M')) {
          const payload: AdditionalServicePayload = {
            id: this.isEdit ? this.dialogData.id : null,
            LGID: null,
            addressId: this.isEdit ? this.dialogData.addressId : this.address ? this.address.id : 0,
            year: parseInt(moment(this.period!.startDate).format('YYYY')),
            month: parseInt(moment(this.period!.startDate).format('M')),
            employeeId: this.employee ? this.employee : 0,
            productId: 0,
            amount: 1,
            price: parseFloat(this.amount!),
            description: this.description,
            currency: this.selectedCurrency!.name,
            type: this.expensesAction === 1 ? '1' : '2'
          }

          this.createAdditionExpensesService(payload)

        } else if (item) {
          const year: number = item === 1 ? parseInt(moment(this.period!.startDate).format('YYYY')) : parseInt(moment(this.period!.endDate).format('YYYY'))
          const month: number = item === 1 ? parseInt(moment(this.period!.startDate).format('M')) : parseInt(moment(this.period!.endDate).format('M'))

          const payload: AdditionalServicePayload = {
            id: this.isEdit ? this.dialogData.id : null,
            LGID: null,
            addressId: this.isEdit ? this.dialogData.addressId : this.address ? this.address.id : 0,
            year: year,
            month: month,
            employeeId: this.employee ? this.employee : 0,
            productId: 0,
            amount: 1,
            price: parseFloat(this.amount!),
            description: this.description,
            currency: this.selectedCurrency!.name,
            type: this.expensesAction === 1 ? '1' : '2'
          }

          this.createAdditionExpensesService(payload)

        } else {
          this.month1 = moment(this.period!.startDate).locale(this.selectedLanguage).format('MMMM')
          this.month2 = moment(this.period!.endDate).locale(this.selectedLanguage).format('MMMM')
          this.showWarningDialog = true
        }
      }
    },

    async createAdditionExpensesService (payload: AdditionalServicePayload): Promise<void> {
      try {
        this.saveInProgress = true
        const response: boolean = await this.$store.dispatch(INSERT_ADDITIONAL_SERVICE_EXPENSES, payload)
        if(response) {
          this.$emit('saved')
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.saveInProgress = false
      }
    },

    async editAdditionExpensesService (payload: AdditionalServicePayload): Promise<void> {
      try {
        this.saveInProgress = true
        const response: boolean = await this.$store.dispatch(EDIT_ADDITIONAL_SERVICE_EXPENSES, payload)
        if(response) {
          this.$emit('saved')
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.saveInProgress = false
      }
    }
  },

  mounted () {
    this.employeeList = (this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]).employeeList.filter((item: Employee) => item.planbar)
    if(this.dialogData) {
      const currency: Currency | undefined = this.currencyList.find((item: Currency) => item.name === this.dialogData.currency)

      this.addressLabel = this.dialogData.addressLabel ? this.dialogData.addressLabel : ''
      this.employee = this.dialogData.employeeId ? this.dialogData.employeeId : null
      this.selectedCurrency = currency ? currency : null
      this.selectedCurrencyName = this.dialogData.currency ? this.dialogData.currency : ''
      this.amount = this.dialogData.price
      this.description = this.dialogData.description
    } else {
      if(this.currencyList.length > 0) {
        const foundCurrency: Currency | undefined = this.currencyList.find((item: Currency) => item.id === this.defaultCurrency)
        this.selectedCurrency = foundCurrency ? foundCurrency : this.currencyList[0]
        this.selectedCurrencyName = foundCurrency ? foundCurrency.name : this.currencyList[0].name
      }
    }

    setTimeout(() => {
      if(this.expensesAction === 1) {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      } else if(!this.isEdit && this.expensesAction === 2) {
        const secondField: any = this.$refs['secondField']
        if (secondField) {
          secondField.focus()
        }
      } else if(this.isEdit  && this.expensesAction === 2) {
        const thirdField: any = this.$refs['thirdField']
        if (thirdField) {
          thirdField.focus()
        }
      }
    }, 0)
  }
})
